export const TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const QR_MODAL_KEY = 'hasSeenModal';
export const WALLET_CHANGE_NOTIFICATION_MODAL_KEY =
  'hasSeenWalletsChangeNotification';
export const HIDE_REFERRAL_CARD = 'hideReferralCard';
export const IS_CARD_WITHDRAW_NEW = 'isCardWithdrawNew';
export const DEPOSIT_CRYPTO_MEMO_REQUIRED_WARNING =
  'hideDepositCryptoMemoWarningModal';
export const DONT_SHOW_DEPOSIT_FIAT_BANKWIRE_DISCLAIMER =
  'dontShowDepositFiatBankwireDisclaimer';

export const BUY_CRYPTO_BANK_WIRE_WARNING = 'hideBuyCryptoBankWireWarning';

export const SELECTED_FIAT_CURRENCY = 'selectedFiatCurrency';
